<div class="p-3  fix-width">
  <div *ngIf="shareObject.data.type === 'list' || shareObject.data.type === 'deleted'">
    <h1 class="fw-bold fs-4 mb-3">{{'title_salary_manager'|translate}}</h1>
    <div>
      <div class="mt-4 border-bottom">
        <!-- Search bar -->
        <div class="w-100 mb-2">
          <div class="d-flex align-items-center justify-content-between gap-2 w-100">
            <div class="d-flex align-items-center gap-2">
              <!-- button back  -->
              <button [disabled]="shareObject.isLoading" class="btn btn-sm btn-warning  rounded-1"
                (click)="sharedService.back()">
                <i class="bi bi-arrow-left"></i>
                <span class="ms-2">{{'btn_back'|translate}}</span>
              </button>
              <button [disabled]="shareObject.isLoading"
                *ngIf="  selectionService.getSelectedRows().size> 0 && shareObject.data.type=='list'"
                class="btn btn-sm btn-danger rounded-1" (click)="deleteItem(selectionService.getSelectedRows())"
                role="button">
                <i class="bi bi-archive"></i>
                <span class="ms-2">{{'btn_soft_delete'|translate}}</span>
              </button>
              <button [disabled]="shareObject.isLoading" class="btn btn-sm btn-info rounded-1" (click)="clear()"
                role="button">
                <i class="bi bi-arrow-clockwise"></i>
                <span class="ms-2">{{'btn_clear'|translate}}</span>
              </button>
              <button [disabled]="shareObject.isLoading" class="btn btn-sm btn-primary rounded-1"
                (click)="shareObject.filterBox = true" role="button">
                <i class="bi bi-funnel"></i>
                <span class="ms-2"> {{'btn_filter'|translate}} </span>
              </button>

            </div>
          </div>
          <!-- search box -->
          <div style="z-index: 1050; width: 600px" class="position-absolute">
            <form *ngIf="shareObject.filterBox===true" [formGroup]="shareObject.filterForm"
              class="advanced-filters shadow-lg bg-white border rounded p-3 mt-2">
              <div class="row g-2">
                <!-- timesheet keyword -->
                <div class="col-md-12">
                  <label class="form-label fw-bold" for="employee">{{'filter_keyword'|translate}}</label>
                  <input type="text" class="form-control form-control-sm" formControlName="employee" id="employee">
                </div>
                <div class="mb-3 col-md-6">
                  <label for="timekeeping" class="form-label fw-bold">{{'timekeeping_type'|translate}}</label>
                  <select class="form-select form-select-sm" formControlName="timekeeping" id="timekeeping">
                    <option value="empty">{{'timekeeping_empty'|translate}}</option>
                    <option *ngFor="let item of sharedService.env.timekeepingTypes" [value]="item.value">
                      {{item.name|translate}}</option>
                  </select>
                </div>
                <div class="col-md-6">
                  <label class="form-label fw-bold" for="group">{{'filter_group'|translate}}</label>
                  <select class="form-select form-select-sm" formControlName="employeeGroup" id="group">
                    <option value="">{{'filter_group_all'|translate}}</option>
                    <option *ngFor="let group of shareObject.employeeGroups" value="{{group.id}}">
                      {{group.name}}
                    </option>
                  </select>
                </div>
                <!-- timesheet keyword -->
                <div class="col-md-3">
                  <div class=" d-flex gap-2" id="btns">
                    <button class="btn btn-primary btn-sm rounded-1"
                      (click)="onSearch()">{{'btn_filter'|translate}}</button>
                    <button class="btn btn-secondary btn-sm rounded-1"
                      (click)="shareObject.filterBox=false">{{'btn_close'|translate}}</button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <!-- filter result -->
        <div class="d-flex gap-2 mb-3 mt-2" *ngIf="shareObject.filters && shareObject.filters.length > 0">
          <span *ngFor="let item of shareObject.filters">
            <span type="button" *ngIf="item.key!=='limit'"
              class="btn btn-outline-danger btn-sm rounded-1 position-relative py-1 fs-8 fw-bold"
              (click)="filterClear(item)">
              {{item.displayValue}}
            </span>
          </span>
        </div>

      </div>
      <div class="fix-height">
        <table class="table table-hover table-striped table-sm">
          <thead class="sticky-top bg-white ">
            <tr class="">
              <th style="width: 50px;">
                <div class="form-check">
                  <input class="form-check-input" role="button" type="checkbox"
                    [checked]="selectionService.isAllSelected(shareObject.users)"
                    (change)="selectionService.toggleSelectAll($event,shareObject.users)" id="checkall">
                  <label class="form-check-label" for="checkall"></label>
                </div>
              </th>
              <th scope="col">{{'salary_employee'|translate}}</th>
              <th scope="col">{{'salary_timekeeping_type'|translate}}</th>
              <th scope="col">{{'formula_salary'|translate}}</th>
              <th scope="col">{{'salary_ratio'|translate}}</th>
              <th scope="col">{{'salary_allowance'|translate}}</th>
              <th scope="col">{{'salary_kpi'|translate}}</th>
              <th scope="col">{{'use_action'|translate}}</th>
            </tr>
          </thead>
          <tbody *ngIf="shareObject.users && shareObject.users.length > 0 && !shareObject.isLoading">
            <tr *ngFor="let item of shareObject.users; let i = index" class="align-middle">
              <!-- check box -->
              <td>
                <div class="form-check">
                  <input class="form-check-input" role="button" type="checkbox"
                    [checked]="selectionService.getSelectedRows().has(i)" (click)="onRowClick($event, i)">
                </div>
              </td>
              <!-- employee info -->
              <td>
                <span>
                  <span class="badge text-bg-primary me-2">{{item?.profile?.employeeId}}</span>
                  <span class="me-2 fw-bold">{{item?.profile?.name}}</span>
                </span>
              </td>
              <!-- timekeeping type -->
              <td>
                <span class="badge text-bg-primary rounded-pill"
                  *ngIf="item?.timekeeping">{{item?.timekeeping?.typeText|translate}}</span>
                <div *ngIf="!item?.timekeeping" class="d-flex gap-2">
                  <span class="fst-italic badge text-bg-secondary rounded-pill">
                    <span>{{'no_timekeeping'|translate}}</span>
                  </span>
                  <span [tooltip]="'add_timekeeping'|translate" routerLink="/user/employee/formula/timekeeping/list"
                    [queryParams]="{ employeeId: item?.profile?.employeeId }">
                    <i role="button" class="bi bi-plus-square text-primary"></i>
                  </span>
                </div>
              </td>
              <!-- salary -->
              <td>
                <span *ngIf="item?.salaryFormula && item?.salaryFormula?.salary > 0">{{item?.salaryFormula?.salary|
                  money }}</span>
                <span *ngIf="!item?.salaryFormula || item?.salaryFormula?.salary == 0">{{0}}</span>
              </td>
              <!-- salary ratio -->
              <td>
                <span *ngIf="item?.salaryFormula?.ratio">{{item?.salaryFormula?.ratio}}%</span>
                <span *ngIf="!item?.salaryFormula?.ratio">0%</span>
              </td>
              <!-- allowance -->
              <td>
                <div *ngIf="item?.salaryFormula?.allowances && item?.salaryFormula?.allowances.length > 0">
                  <ng-template #htmlTooltip let-item="item">
                    <div *ngIf="item?.salaryFormula?.allowances?.length">
                      <div *ngFor="let a of item.salaryFormula.allowances" class="d-flex gap-3">
                        <span class="">{{ a?.name }}</span>
                        <span class="">{{ a?.amount | money }}</span>
                      </div>
                    </div>
                  </ng-template>

                  <div class="fw-bold text-truncate fs-8" [tooltip]="htmlTooltip" [html]="true"
                    [tooltipCtx]="{ item: item }" [html]="true" placement="top" customClass="my-tooltip">
                    <span class="fs-6 fw-medium">{{ item?.salaryFormula?.allowanceAmount | money }}</span>
                  </div>
                </div>
                <div *ngIf="!item?.salaryFormula?.allowances || item?.salaryFormula?.allowances.length == 0">
                  <span class="badge text-bg-light fst-italic text-muted">{{'no_allowance'|translate}}</span>
                </div>
              </td>
              <!-- salary kpi -->
              <td class="p-0">
                <ng-template #htmlTooltip let-item="item">
                  <div *ngIf="item?.salaryFormula?.kpi?.length">
                    <div *ngFor="let k of item.salaryFormula.kpi" class="d-flex gap-3">
                      <span class="">{{ k?.kpiUnit?.name }}</span>
                      <span class="">{{ k?.price | money }}</span>
                    </div>
                  </div>
                </ng-template>

                <div *ngIf="item?.salaryFormula?.kpi && item?.salaryFormula?.kpi?.length > 0"
                  class="fw-bold text-truncate fs-8" [tooltip]="htmlTooltip" [html]="true" [tooltipCtx]="{ item: item }"
                  [html]="true" placement="top" customClass="my-tooltip">
                  <span class="fs-6 fw-medium">{{ item?.salaryFormula?.kpiAmount | money}}</span>
                </div>


                <div *ngIf="!item.salaryFormula?.kpi || item.salaryFormula?.kpi.length == 0">
                  <span class="badge text-bg-light fst-italic text-muted">{{'no_data'|translate}}</span>
                </div>
              </td>
              <!-- action -->
              <td>
                <div class="d-flex gap-2" *ngIf="shareObject.data.type === 'list'">
                  <span class="btn btn-success btn-sm rounded-1 py-0" *ngIf="!item?.salaryFormula"
                    (click)="getItemValue(item, 0)">
                    <i class="bi bi-plus-circle me-2"></i>
                    {{'btn_add'|translate}}
                  </span>
                  <span class="btn btn-primary btn-sm rounded-1 py-0" *ngIf="item?.salaryFormula"
                    (click)="getItemValue(item)">
                    <i class="bi bi-pencil-square me-2"></i>
                    {{'btn_edit'|translate}}
                  </span>
                  <span *ngIf="item?.salaryFormula" class="btn btn-danger btn-sm rounded-1 py-0"
                    (click)="deleteItem([i])">
                    <i class="bi bi-archive me-2"></i>
                    {{'btn_soft_delete'|translate}}
                  </span>
                </div>
              </td>
            </tr>
          </tbody>
          <caption *ngIf="shareObject.users && shareObject.users.length === 0">
            <div class="text-center">
              {{'no_data'|translate}}
            </div>
          </caption>
          <caption *ngIf="shareObject.isLoading">
            <div class="text-center">
              <div class="spinner-border spinner-border-sm text-secondary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
          </caption>
        </table>
      </div>
      <app-pagination [pagingOptions]="shareObject.options" [pagination]="shareObject.pagination"
        (changePage)="onPageChange($event)"></app-pagination>
    </div>
  </div>
  <div *ngIf="shareObject.data.type === 'table'">
    <div class="hide-on-print">
      <ul class="nav nav-tabs">
        <li class="nav-item" *ngFor="let item of shareObject.tabList">
          <a class="nav-link" [ngClass]="{'active': shareObject.active === item.key}"
            [attr.aria-current]="shareObject.active === item.key ? 'page' : null" [routerLink]="shareObject.listURL"
            [queryParams]="{ type: item.key }">
            {{item.name | translate}}
          </a>
        </li>
      </ul>

    </div>
    <div class="mt-3">
      <div class="mb-2 d-flex gap-2 hide-on-print">
        <div>
          <button [disabled]="shareObject.isLoading" class="btn btn-sm btn-primary rounded-1" (click)="window.print()">
            <i class="bi bi-print"></i>
            <span class="ms-2">{{'btn_print'|translate}}</span>
          </button>
        </div>
        <div>
          <button [disabled]="shareObject.isLoading" class="btn btn-sm btn-primary rounded-1"
            (click)="shareObject.filterBox = true" role="button">
            <i class="bi bi-funnel"></i>
            <span class="ms-2"> {{'btn_filter'|translate}} </span>
          </button>
        </div>
        <div>
          <button [disabled]="shareObject.isLoading" class="btn btn-sm btn-primary rounded-1" (click)="clear()"
            role="button">
            <i class="bi bi-arrow-clockwise"></i>
            <span class="ms-2"> {{'btn_clear'|translate}} </span>
          </button>
        </div>
        <div style="z-index: 1050; width: 600px" class="position-absolute">
          <form *ngIf="shareObject.filterBox===true" [formGroup]="shareObject.filterForm"
            class="advanced-filters shadow-lg bg-white border rounded p-3 mt-2">
            <div class="row g-2">
              <!-- keyword -->
              <div class="col-md-12">
                <label class="form-label fw-bold" for="keyword">{{'filter_keyword'|translate}}</label>
                <input type="text" class="form-control form-control-sm" formControlName="keyword" id="keyword">
              </div>
              <div class="col-md-6">
                <label class="form-label fw-bold" for="group">{{'filter_group'|translate}}</label>
                <select class="form-select form-select-sm" formControlName="employeeGroup" id="group">
                  <option value="">{{'filter_group_all'|translate}}</option>
                  <option *ngFor="let group of shareObject.employeeGroups" value="{{group.id}}">
                    {{group.name}}
                  </option>
                </select>
              </div>
              <!-- page size -->
              <div class="col-md-6">
                <label class="form-label fw-bold" for="pagesize">{{"page_size"|translate}}</label>
                <select class="form-select form-select-sm" formControlName="limit" id="pagesize">
                  <option *ngFor="let size of sharedService.env.pageSize" value="{{size}}">{{size}}
                  </option>
                </select>
              </div>
              <div class="col-md-4">
                <label class="form-label fw-bold" for="date">{{'filter_start_date'|translate}}</label>
                <input type="date" class="form-control form-control-sm" formControlName="start" id="start">
              </div>
              <div class="col-md-4">
                <label class="form-label fw-bold" for="date">{{'filter_end_date'|translate}}</label>
                <input type="date" class="form-control form-control-sm" formControlName="end" id="end">
              </div>
              <div class="col-md-3">
                <label class="form-label fw-bold mb-4" for="btns"></label>
                <div class=" d-flex gap-2" id="btns">
                  <button class="btn btn-primary btn-sm rounded-1"
                    (click)="onSearch()">{{'btn_filter'|translate}}</button>
                  <button class="btn btn-secondary btn-sm rounded-1"
                    (click)="shareObject.filterBox=false">{{'btn_close'|translate}}</button>
                  <!-- <button class="btn btn-primary btn-sm rounded-1"
                              (click)="refresh()">{{'btn_clear'|translate}}</button> -->
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <!-- filter result -->
      <div class="d-flex gap-2 mb-3 mt-2" *ngIf="shareObject.filters && shareObject.filters.length > 0">
        <span *ngFor="let item of shareObject.filters">
          <span type="button" *ngIf="item.key!=='limit'"
            class="btn btn-outline-danger btn-sm rounded-1 position-relative py-1 fs-8 fw-bold"
            (click)="filterClear(item)">
            {{item.displayValue}}
          </span>
        </span>
      </div>
      <!-- Tính lương theo loại -->
      <div *ngIf="shareObject.active === 'day'">
        <app-table-day [shareObject]="shareObject" (toggle)="toggleRow($event.id, $event.expand)"
          (allPayslip)="addAllPayslip($event)" (exportToExcel)="exportSalaryToExcel($event.groupDatas, $event.columns, $event.timeObj)"
          (payslip)="addPayslip($event)"></app-table-day>
      </div>
      <div *ngIf="shareObject.active === 'hour'">
        <app-table-hour [shareObject]="shareObject" (toggle)="toggleRow($event.id, $event.expand)"
          (allPayslip)="addAllPayslip($event)" (payslip)="addPayslip($event)"></app-table-hour>
      </div>
      <div *ngIf="shareObject.active === 'kpi'">
        <app-table-kpi [shareObject]="shareObject" (toggle)="toggleRow($event.id, $event.expand)"
          (allPayslip)="addAllPayslip($event)" (payslip)="addPayslip($event)"></app-table-kpi>
      </div>
    </div>
  </div>
</div>
<!-- modal add salary formula-->
<div class="modal" id="add-item" tabindex="-1">
  <div class="modal-dialog" *ngIf="shareObject.employeeChecked">
    <div class="modal-content">
      <div class="modal-header">
        <div class="modal-title">{{shareObject?.employeeChecked?.profile?.name}}</div>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="mb-3 fw-bold">{{shareObject?.employeeChecked?.timekeeping?.typeText|translate }}</div>
        <form [formGroup]="formHandle">
          <div *ngIf="shareObject?.employeeChecked?.timekeeping?.type !=constants.TIMEKEEPING.KPI">
            <div class="mb-3">
              <label for="salary" class="form-label">{{'salary_basic'|translate}}</label>
              <input type="number" class="form-control form-control-sm" formControlName="salary" id="salary">
            </div>
          </div>
          <div class="mb-3">
            <label for="salaryAbsence" class="form-label">{{'salary_absence'|translate}}</label>
            <input type="number" min="1" max="100" class="form-control form-control-sm" formControlName="salaryAbsence"
              id="salaryAbsence">
          </div>
          <div class="mb-3">
            <label for="ratio" class="form-label">{{'salary_ratio'|translate}}</label>
            <input type="number" min="1" max="100" class="form-control form-control-sm" formControlName="ratio"
              id="ratio">
          </div>
          <div
            *ngIf="[constants.TIMEKEEPING.KPI,constants.TIMEKEEPING.DAY_KPI, constants.TIMEKEEPING.HOUR_KPI ].includes(shareObject?.employeeChecked?.timekeeping?.type)"
            class="mb-3">
            <label for="salary-kpi" class="form-label">{{'salary_kpi'|translate}}</label>
            <div class="table" id="salary-kpi" *ngIf="shareObject.kpiFormulas && shareObject.kpiFormulas.length > 0">
              <table class="table table-bordered table-sm align-middle">
                <thead class="table-light">
                  <tr>
                    <th>#</th>
                    <th>{{ 'unit' | translate }}</th>
                    <th>{{ 'price' | translate }}</th>
                    <th>{{'action'|translate}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of shareObject.kpiFormulas; let i = index">
                    <td>{{ i + 1 }}</td>
                    <td>
                      <select name="" class="form-select form-select-sm" id=""
                        (change)="changeKpiFormula(i, 'kpiUnit', $event)">
                        <option *ngFor="let k of shareObject.kpiUnits" [value]="k.id" [selected]="k.id == item.kpiUnit">
                          {{ getName(k.id) }}
                        </option>
                      </select>
                    </td>
                    <td> <input type="number" (change)="changeKpiFormula(i, 'price', $event)"
                        class="form-control form-control-sm" [value]="item.price" />
                    </td>
                    <td>
                      <span class="btn btn-sm btn-danger rounded-1" (click)="removeKpiFormula(i)">
                        <i class="bi bi-trash"></i>
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div>
            </div>
            <span class="btn btn-sm btn-primary rounded-1" (click)="addKpiFormula()">
              <i class="bi bi-plus me-2"></i>
              {{'btn_add'|translate}}
            </span>

          </div>
          <!-- Phụ cấp -->
          <div>
            <label for="salary-allowance" class="form-label">{{'salary_allowance'|translate}}</label>
            <div *ngIf="shareObject.allowances && shareObject.allowances.length > 0" class="mb-3 "
              id="salary-allowance">
              <table class="table table-bordered table-sm align-middle">
                <thead class="table-light">
                  <tr>
                    <th>#</th>
                    <th>{{ 'allowance_name' | translate }}</th>
                    <th>{{ 'allowance_amount' | translate }}</th>
                    <th>{{ 'btn_action' | translate }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of shareObject.allowances; let i = index">
                    <td>{{ i + 1 }}</td>
                    <td>
                      <select id="name-{{ i }}" class="form-control form-control-sm"
                        (change)="changeAllowance(i, 'allowance', $event)">
                        <option *ngFor="let option of shareObject.allowanceList" [value]="option.id"
                          [selected]="item.allowance == option.id">
                          {{ option.name }}
                        </option>
                      </select>
                    </td>
                    <td>
                      <input id="amount-{{ i }}" type="number" class="form-control form-control-sm"
                        [value]="item.amount" (change)="changeAllowance(i, 'amount', $event)" />
                    </td>
                    <td>
                      <button type="button" class="btn btn-sm rounded-1 btn-danger" (click)="removeAllowance(i)">
                        <i class="bi bi-trash me-1"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div>
              <span class="btn btn-sm btn-primary rounded-1" (click)="addAllowance()">
                <i class="bi bi-plus me-2"></i>
                {{'btn_add_allowance'|translate}}
              </span>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
          {{'btn_close'|translate}}
        </button>
        <button type="button" class="btn btn-primary" (click)="onSubmit()">{{'btn_save'|translate}}</button>
      </div>
    </div>
  </div>
</div>

<!-- modal add salary component-->
<div class="modal" id="add-component" tabindex="-1">
  <div class="modal-dialog modal-lg">
    <div class="modal-content" *ngIf="shareObject.employeeShow">
      <div class="modal-header">
        <div class="modal-title">{{'title_add_salary_component'|translate}}</div>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <app-salary-component-add [employee]="shareObject.employeeShow" col="12"
          [isGetData]="false"></app-salary-component-add>
      </div>
    </div>
  </div>
</div>